var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Radio } from '@material-ui/core';
import classNames from 'classnames';
import { default as React, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import { ArrowDownIcon, ArrowUpIcon } from '../../Components/Icons';
import { iconLight } from '../../Styles/Colours';
import styles from './PaymentSchemeDisplaySection.module.css';
export var PaymentSchemeDisplaySection = function (props) {
    var _a;
    var _b, _c, _d;
    var selectable = !!props.indication;
    var hasTreatmentPhase = !!((_b = props.indication) === null || _b === void 0 ? void 0 : _b.treatmentPhase);
    var _e = __read(useState(false), 2), open = _e[0], setOpen = _e[1];
    var toggleStyles = {
        size: '24',
        color: iconLight
    };
    function processContent() {
        if (props.innerHtml) {
            var sanitised = sanitizeHtml(props.innerHtml);
            var spaceAnd = sanitised.replace(/(AND )/gm, "\n\n$1\n\n");
            var spacePhrases = spaceAnd.replace(/((Treatment Phase|Clinical criteria|Treatment criteria|Population criteria): )/gim, "\n\n$1\n\n");
            var spaceBullets = spacePhrases.replace(/ (\*|\((i|ii|iii|iv|v|vi|vii|viii|ix|x|[a-z])\)) /gm, "\n\n$1 ");
            var boldedAnd = spaceBullets.replace(/(AND)/gm, "<strong>$1</strong>");
            return boldedAnd.replace(/((Treatment Phase|Clinical criteria|Treatment criteria|Population criteria): )/gim, "<strong>$1</strong>");
        }
        else {
            return 'None';
        }
    }
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: classNames(styles.titleBar, (_a = {},
                _a[styles.selectable] = selectable,
                _a[styles.readOnly] = props.readOnly,
                _a)), onClick: function (e) {
                e.stopPropagation();
                if (props.readOnly)
                    return;
                setOpen(function (it) { return !it; });
            } },
            selectable && !props.readOnly && (React.createElement("div", { className: styles.toggle },
                React.createElement(Radio, { checked: props.active, onClick: function (e) {
                        e.stopPropagation();
                        if (props.readOnly)
                            return;
                        if (props.onClick)
                            props.onClick();
                    }, name: 'radio-button-demo', "data-test-id": 'scheme-toggle' }))),
            React.createElement("div", { className: styles.title }, props.title),
            selectable && React.createElement("div", { className: styles.name }, (_c = props.indication) === null || _c === void 0 ? void 0 : _c.name),
            selectable && (React.createElement("div", { className: styles.treatmentPhase }, hasTreatmentPhase && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles.treatmentPhaseTitle }, "Treatment Phase: "), (_d = props.indication) === null || _d === void 0 ? void 0 :
                _d.treatmentPhase)))),
            !props.readOnly && (React.createElement("div", { className: styles.arrow }, open ? React.createElement(ArrowUpIcon, __assign({}, toggleStyles)) : React.createElement(ArrowDownIcon, __assign({}, toggleStyles))))),
        open && props.indication && (React.createElement("div", { className: styles.subTable },
            React.createElement("div", { className: styles.headerRow },
                React.createElement("div", { className: styles.column }, "PBS prescribers"),
                React.createElement("div", { className: styles.column }, "Max PBS packs"),
                React.createElement("div", { className: styles.column }, "Max PBS repeats")),
            React.createElement("div", { className: styles.row },
                React.createElement("div", { className: styles.column }, props.indication.prescriberGroups.map(function (it, index) { return (React.createElement("span", { key: it.code + "-" + index }, "" + (index !== 0 ? ', ' : '') + it.name)); })),
                React.createElement("div", { className: styles.column }, props.indication.maxNumberOfPacks),
                React.createElement("div", { className: styles.column }, props.indication.maxNumberOfRepeats)))),
        open && React.createElement("div", { className: styles.fullContent, dangerouslySetInnerHTML: { __html: processContent() } })));
};
